import { z } from 'zod';

const LeaderboardSchema = z.object({
  value: z.number(),
  nick: z.string(),
  position: z.number().int(),
  rank: z.number().int(),
  operatorId: z.string(),
});
export type LeaderboardData = z.infer<typeof LeaderboardSchema>;

export const GameLeaderboardsSchema = z.object({
  lastUpdated: z.number(),
  leaderboardData: z.record(z.string(), LeaderboardSchema),
});
export type GameLeaderboardsData = z.infer<typeof GameLeaderboardsSchema>;
